"use strict";

var _regeneratorRuntime = require("/home/runner/work/website/website/node_modules/@babel/runtime/regenerator/index.js");
var _classCallCheck = require("/home/runner/work/website/website/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/runner/work/website/website/node_modules/@babel/runtime/helpers/createClass.js");
var _possibleConstructorReturn = require("/home/runner/work/website/website/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/home/runner/work/website/website/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _inherits = require("/home/runner/work/website/website/node_modules/@babel/runtime/helpers/inherits.js");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NinetailedGoogleTagmanagerPlugin = void 0;
var tslib_1 = require("tslib");
var experience_js_plugin_analytics_1 = require("@ninetailed/experience.js-plugin-analytics");
var experience_js_shared_1 = require("@ninetailed/experience.js-shared");
var TEMPLATE_OPTIONS = {
  interpolate: /{{([\s\S]+?)}}/g
};
var NinetailedGoogleTagmanagerPlugin = /*#__PURE__*/function (_experience_js_plugin) {
  function NinetailedGoogleTagmanagerPlugin() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, NinetailedGoogleTagmanagerPlugin);
    _this = _callSuper(this, NinetailedGoogleTagmanagerPlugin, [Object.assign(Object.assign({}, options.template), {
      event: 'nt_experience',
      ninetailed_variant: '{{selectedVariantSelector}}',
      ninetailed_experience: '{{experience.id}}',
      ninetailed_experience_name: '{{experience.name}}',
      ninetailed_audience: '{{audience.id}}',
      ninetailed_component: '{{selectedVariant.id}}'
    })]);
    _this.options = options;
    _this.name = 'ninetailed:googleTagmanager';
    _this.initialize = function () {
      if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || [];
      }
    };
    return _this;
  }
  _inherits(NinetailedGoogleTagmanagerPlugin, _experience_js_plugin);
  return _createClass(NinetailedGoogleTagmanagerPlugin, [{
    key: "onTrackExperience",
    value: function onTrackExperience(properties, hasSeenExperienceEventPayload) {
      var _a;
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push(hasSeenExperienceEventPayload);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    }
  }, {
    key: "onTrackComponent",
    value: function onTrackComponent(properties) {
      var _a;
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var variant, audience, isPersonalized, action, label;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              variant = properties.variant, audience = properties.audience, isPersonalized = properties.isPersonalized;
              action = (0, experience_js_shared_1.template)(this.options.actionTemplate || 'Has Seen Experience', {
                component: variant,
                audience: audience
              }, TEMPLATE_OPTIONS.interpolate);
              label = (0, experience_js_shared_1.template)(this.options.labelTemplate || '{{ baselineOrVariant }}:{{ component.id }}', {
                component: variant,
                audience: audience,
                baselineOrVariant: isPersonalized ? 'Variant' : 'Baseline'
              }, TEMPLATE_OPTIONS.interpolate);
              (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({
                event: action,
                properties: {
                  category: 'Ninetailed',
                  label: label,
                  nonInteraction: true
                }
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }]);
}(experience_js_plugin_analytics_1.NinetailedAnalyticsPlugin);
exports.NinetailedGoogleTagmanagerPlugin = NinetailedGoogleTagmanagerPlugin;